import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _pt from "prop-types";
import React from 'react';
import shallowEqual from './utils/shallowEqual';
import updateMultipleDatasetsInView from './utils/updateMultipleDatasetsInView';
import VegaEmbed from './VegaEmbed';
import { NOOP } from './constants';
var EMPTY = {};

var Vega = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Vega, _React$PureComponent);

  function Vega() {
    var _context;

    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;

    _defineProperty(_assertThisInitialized(_this), "vegaEmbed", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleNewView", function (view) {
      _this.update();

      var _this$props$onNewView = _this.props.onNewView,
          onNewView = _this$props$onNewView === void 0 ? NOOP : _this$props$onNewView;
      onNewView(view);
    });

    return _this;
  }

  var _proto = Vega.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.update();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!shallowEqual(this.props.data, prevProps.data)) {
      this.update();
    }
  };

  _proto.update = function update() {
    var data = this.props.data;

    if (data) {
      if (this.vegaEmbed.current && _Object$keys(data).length > 0) {
        this.vegaEmbed.current.modifyView(function (view) {
          updateMultipleDatasetsInView(view, data);
          view.resize().run();
        });
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["data"]);

    return React.createElement(VegaEmbed, _extends({
      ref: this.vegaEmbed
    }, restProps, {
      onNewView: this.handleNewView
    }));
  };

  return Vega;
}(React.PureComponent);

_defineProperty(Vega, "defaultProps", {
  data: EMPTY
});

export { Vega as default };